import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverviewComponent } from './overview/overview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule as MatCardModule } from '@angular/material/card';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { BarchartComponent } from './barchart/barchart.component';
import { MultiToggleComponent } from './multi-toggle/multi-toggle.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {  RouterModule } from '@angular/router';
import { ReportingFrameComponent } from './reporting-frame/reporting-frame.component';
import { CommonUIModule } from '@sdbn/common';
import { ReportDaySelectionWidget } from './report-day-selection/report-day-selection.component';

import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { StructureNodeSelectionModule } from '../../components/structure-node-selection/structure-node-selection.module';
import { ForecastModule } from './forecast/forecast.module';
import { StatusModule } from './status/status.module';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule as MatChipsModule } from '@angular/material/chips';

@NgModule({
  declarations: [
    OverviewComponent,
    BarchartComponent,
    MultiToggleComponent,
    ReportingFrameComponent,
    ReportDaySelectionWidget
  ],
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    RouterModule,
    CommonUIModule,
    CommonLayoutModule,
    CommonTranslationModule,
    StructureNodeSelectionModule,
    ForecastModule,
    StatusModule,
    MatCheckboxModule,
    MatChipsModule
  ]
})
export class ReportingModule { }
